import { withTheme } from '../config';
import { PricingCard, } from '@rneui/base/dist/PricingCard/PricingCard';
export { PricingCard };
export default withTheme(PricingCard, 'PricingCard');
